import { Stack, TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { IPartnerContactFormValues } from "src/entities/partners/model/types";
import { useGetPartnerDropdownsQuery } from "src/shared/api/dropdowns/partner";
import { SelectField, DatePickerField } from "src/shared/components";
import { messages } from "src/shared/utils/hookFormRules";

export const GeneralInfo: FC = () => {
  const { control } = useFormContext<IPartnerContactFormValues>();
  const { data: dropdowns } = useGetPartnerDropdownsQuery();
  const { partner_person_sex, partner_person_position } = dropdowns || {};

  return (
    <Stack spacing={5} sx={{ pt: 2 }}>
      <Controller
        control={control}
        name="lastname"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Фамилия"
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name={"firstname"}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Имя"
            error={!!error}
            helperText={error?.message}
          />
        )}
        rules={{ required: messages.required }}
      />
      <Controller
        control={control}
        name={"surname"}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Отчество"
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
      <Controller
        control={control}
        name={"sex"}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <SelectField
            inputRef={ref}
            fullWidth
            {...field}
            label="Пол"
            error={!!error}
            helperText={error?.message}
            options={partner_person_sex}
          />
        )}
      />
      <Controller
        control={control}
        name={"position"}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <SelectField
            inputRef={ref}
            fullWidth
            {...field}
            label="Должность"
            error={!!error}
            helperText={error?.message}
            options={partner_person_position}
          />
        )}
      />
      <Controller
        name="birthday"
        control={control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <DatePickerField
            inputRef={ref}
            {...field}
            disableFuture
            error={error}
            label="Дата рождения"
          />
        )}
      />
    </Stack>
  );
};
